import styled from 'styled-components'
import { Box } from '../../UI/Box'
import { pagePaddingCssRules } from '../../Header/styles'

export const FooterContainer = styled.div`
  position: relative;
  z-index: 0;
  min-height: 450px;
  align-items: center;
  z-index: 9;
  border-top: 1px solid ${({ theme }) => theme.semantics.zap.stroke.tertiary};
  padding: 32px 0;
  @media screen and (max-width: 1000px) {
    height: 100%;
  }

  @media screen and (max-width: 800px) {
    justify-content: center;
    flex-direction: column;
  }

  a {
    white-space: nowrap;
  }

  &::after {
    position: absolute;
    content: '';
    pointer-events: none;
    height: 100%;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
    background: url('../../../styles/images/background-footer.png');
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 900px) {
      background-size: cover;
    }
  }

  ${pagePaddingCssRules}
  padding-top: 32px !important;
  padding-bottom; 32px !important;
  
  @media screen and (max-width: ${({ theme }) =>
    theme.layout.medium.indexGrids.maxWidth}px) {
    margin-bottom: 150px;
  }
`

export const Title = styled.h4`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 36px;

  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  margin-bottom: 12px;
`

export const Link = styled.a`
  color: rgba(255, 255, 255, 1);
  font-variant-numeric: oldstyle-nums proportional-nums;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  opacity: 0.4;
  :hover {
    opacity: 1;
  }
`

export const FooterColumns = styled.div<{ wrap?: string | null }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  @media screen and (max-width: 800px) {
    margin-bottom: 96px;
  }
`

export const AddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  min-width: 300px;
  @media screen and (max-width: 800px) {
    margin-top: 64px;
    justify-content: center;
    align-items: flex-start;
    position: absolute;
    bottom: 16px;
  }
`

export const LogoLink = styled.a`
  display: flex;
  margin: 0 !important;
  justify-content: flex-end;
`

export const AddressText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  max-width: 186px;
  opacity: 0.5;
  @media screen and (max-width: 800px) {
    text-align: left;
    margin-top: 16px;
  }
`

export const Copyright = styled.span`
  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  opacity: 0.3;
`

export const SocialText = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;

  transition: 0.3s ease-in-out;
  @media screen and (max-width: 800px) {
    display: none;
  }
`

export const SocialLink = styled.a`
  flex: 1;
`

export const SectionTitle = styled.div`
  color: #fff;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 25px; /* 156.25% */
  letter-spacing: 4.8px;
  text-transform: uppercase;
`

export const Product = styled(Box)`
  color: #fff;
  font-variant-numeric: oldstyle-nums proportional-nums;
  font-family: 'Space Grotesk';
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 33.6px */
  letter-spacing: -0.28px;
  text-transform: uppercase;
`

export const LeftBox = styled(Box)`
  height: 262px;
  align-items: flex-start;
  @media screen and (max-width: 1000px) {
    height: auto;
    gap: 80px;
    flex-direction: column;
  }
`

export const ProductsBox = styled(Box)``

export const ProductsLinksCont = styled(Box)`
  @media screen and (max-width: 1000px) {
    gap: 24px;
    flex-direction: column;
  }
`

export const LinksBox = styled(Box)`
  align-items: flex-end;
  @media screen and (max-width: 1000px) {
    gap: 20px;
    flex-direction: column;
  }
`

export const RightBox = styled(Box)`
  height: 262px;
  align-items: flex-end;
  @media screen and (max-width: 1000px) {
    height: auto;
    flex-direction: row;
  }
`

export const SocialLinksBox = styled(Box)`
  @media screen and (max-width: 1000px) {
    align-items: flex-start;
  }
`

export const FooterBox = styled(Box)`
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    gap: 80px;
  }
`
